// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__1YN20","close":"Badge_close__JwwHm","small":"Badge_small__1IqlP"};